import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import tw from 'twin.macro';
import { POLICY_PAGES, brandPolicies, brandPolicyTitle, getBrand } from '../../constants/brands';

const NavigationContainer = styled.div`
  ${tw`bg-white rounded-lg shadow-card-hover p-6`}

  @media (min-width: 768px) {
    ${tw`sticky top-8`}
  }
`;

const NavigationTitle = styled.h2`
  ${tw`text-lg font-bold mb-4 text-text-primary`}
`;

const NavigationList = styled.ul`
  ${tw`list-none p-0 m-0`}
`;

const NavigationItem = styled.li`
  ${tw`mb-0`}
`;

interface NavigationLinkProps {
  $isActive?: boolean;
}

const NavigationLink = styled.button<NavigationLinkProps>`
  ${tw`
    w-full
    text-left
    py-3
    px-4
    rounded-md
    transition-colors
    duration-200
    border-none
    bg-transparent
    cursor-pointer
    text-base
  `}

  ${props =>
    props.$isActive
      ? tw`bg-purple-100 text-black font-semibold`
      : css`
          ${tw`text-text-primary`}
          &:hover {
            ${tw`bg-bg-secondary`}
          }
        `}
`;

interface PolicyNavigationProps {
  currentPath: string;
}

const PolicyNavigation: React.FC<PolicyNavigationProps> = ({ currentPath }) => {
  const navigate = useNavigate();

  const brand = getBrand();
  const policies = brandPolicies(brand).map(doc => ({
    path: POLICY_PAGES[doc].route,
    label: brandPolicyTitle(doc, brand),
  }));

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <NavigationContainer>
      <NavigationTitle>Terms and policies</NavigationTitle>
      <NavigationList>
        {policies.map(policy => (
          <NavigationItem key={policy.path}>
            <NavigationLink
              $isActive={currentPath === policy.path}
              onClick={() => handleNavigation(policy.path)}
            >
              {policy.label}
            </NavigationLink>
          </NavigationItem>
        ))}
      </NavigationList>
    </NavigationContainer>
  );
};

export default PolicyNavigation;
